import { keyframes } from 'styled-components';
export const buttonShakeAnimationKeyframes = keyframes`
  from,
  to {
    transform: translate3d(0, 0, 0);
  }

  17%,
  51% {
    transform: translate3d(-10px, 0, 0);
  }

  34%,
  68% {
    transform: translate3d(10px, 0, 0);
  }

  84% {
    transform: translate3d(-5px, 0, 0);
  }
`;